import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { UtilitiesService } from 'app/store/services/utilities.servive';

@Component({
  selector: 'app-table-search-filter',
  templateUrl: './table-search-filter.component.html',
  styleUrls: ['./table-search-filter.component.scss'],
})
export class TableSearchFilterComponent implements OnInit {

  @Input() placeholder: string;

  @Input() buttonLabel = 'Search';

  @Output() search: EventEmitter<string> = new EventEmitter<string>();

  @Input() inputValue: string;

  @Input() disabled: boolean;

  @Input() value: string;

  iconClose = faTimes;

  constructor(
    private readonly utilService: UtilitiesService
  ) {
  }

  ngOnInit(): void {
  }

  getTestId(predefined?: string) {
    if (predefined) {
      return this.utilService.getTestIdProp(`${predefined}`);
    }

    return this.utilService.getTestIdProp('table-search-filter-button');
  }
  onSearch() {
    this.search.emit(this.inputValue);
  }

  onClearInput() {
    this.inputValue = '';
    this.search.emit(this.inputValue);
  }
}
